import { render, staticRenderFns } from "./iMResponsible.vue?vue&type=template&id=0116b448&scoped=true"
import script from "./iMResponsible.vue?vue&type=script&lang=js"
export * from "./iMResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0116b448",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0116b448')) {
      api.createRecord('0116b448', component.options)
    } else {
      api.reload('0116b448', component.options)
    }
    module.hot.accept("./iMResponsible.vue?vue&type=template&id=0116b448&scoped=true", function () {
      api.rerender('0116b448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/list/iMResponsible.vue"
export default component.exports